export const ACCESS_TOKEN_COOKIE_NAME = 'USER_DATA';
export const ACCESS_TOKEN_COOKIE_ORIGIN_PARAM = 'origin';
export const ACCESS_TOKEN_TYPE = 'Bearer';
export const MD_AUTH_LOCAL_STORAGE_KEY = 'md_auth';

export const FROM_IN_APP_BROWSER = 'InAppBrowser';
export const SIGN_IN_ROUTE = '/sign-in';
export const SIGN_UP_ROUTE = '/sign-up';

export const ADMIN_USER_COOKIE_NAME = 'admin_user';
